import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ResCol } from "@/components/network/parts";
import { RunsText } from "@/components/appointments/MessageCard";

export default function ToolsIndex({ skill, navById }) {
  return (
    <div className="divide-y divide-slate-200 rounded-2xl border border-slate-200 bg-white" data-testid="net-tools-index">
      {skill.sections.map((s, i) => (
        <div key={i} className="p-4 flex flex-col gap-3" data-testid={`net-tool-${i}`}>
          <div className="space-y-1">
            <div className="text-sm font-semibold text-[#0A1F44]">{s.label}</div>
            <RunsText runs={s.body} className="text-xs text-slate-600" />
            <div className="flex flex-wrap gap-1.5 pt-1">
              {(s.appears_in || []).map((id) => (
                <Link key={id} to={`/network/${id}`} data-testid={`net-tool-${i}-skill-${id}`}
                      className="inline-flex items-center gap-1 rounded-full bg-[#0A1F44]/5 text-[#0A1F44] text-[11px] font-medium px-2.5 py-1 hover:bg-[#0A1F44]/10">
                  {navById[id]} <ArrowRight className="w-3 h-3" />
                </Link>
              ))}
              {s.internal && (
                <Link to={s.internal} data-testid={`net-tool-${i}-internal`}
                      className="inline-flex items-center gap-1 rounded-full bg-[#C9A961]/20 text-[#0A1F44] text-[11px] font-semibold px-2.5 py-1 hover:bg-[#C9A961]/30">
                  Open in Team Smith Hub <ArrowRight className="w-3 h-3" />
                </Link>
              )}
            </div>
          </div>
          <ResCol sec={s} testid={`net-tool-${i}`} />
        </div>
      ))}
    </div>
  );
}
